export default __webpack_public_path__ + "static/media/instagramWallVarsovie.60a58eaa.jpg";